import React from 'react';
import { Link } from 'react-router-dom';
import './Cart.css';
import { useCart } from '../context/CartContext';
import LampThumbnail from './LampThumbnail';

function Cart() {
  const { cartItems, updateQuantity, removeFromCart, getCartTotal, clearCart } = useCart();

  return (
    <div className="cart-page">
      <div className="cart-container">
        {cartItems.length === 0 ? (
          <div className="empty-cart">
            <p>your cart is empty</p>
            <Link to="/shop" className="continue-shopping" aria-label="Continue shopping">
              continue shopping
            </Link>
          </div>
        ) : (
          <div className="cart-content">
            <section className="cart-items" aria-label="Cart items">
              {cartItems.map(item => (
                <div key={item.id} className="cart-item">
                  <div className="cart-thumb">
                    {item.design ? (
                      <LampThumbnail design={item.design} alt={item.name} />
                    ) : (item.baseShape && item.modifiers ? (
                      <LampThumbnail design={{ baseShape: item.baseShape, modifiers: item.modifiers, rendering: item.rendering, noiseSeed: item.noiseSeed, id: item.id }} alt={item.name} />
                    ) : null)}
                  </div>
                  <div className="cart-info">
                    <div className="cart-name">{item.name}</div>
                    <div className="cart-desc">{item.description}</div>
                    {item.specifications && (
                      <div className="cart-specs">
                        {item.specifications.dimensions && <span>{item.specifications.dimensions}</span>}
                        {item.specifications.material && <span> | {item.specifications.material}</span>}
                        {item.specifications.color && (
                          <span className="color-swatch-container">
                            {' | '}
                            <span 
                              className="color-swatch" 
                              style={{ backgroundColor: item.specifications.color }}
                              title={item.specifications.color}
                              aria-label={`Color: ${item.specifications.color}`}
                            />
                          </span>
                        )}
                      </div>
                    )}
                  </div>
                  <div className="cart-price">
                    <span>{item.price}</span>
                  </div>
                  <div className="cart-qty">
                    <button onClick={() => updateQuantity(item.id, item.quantity - 1)} className="cart-btn qty-btn" aria-label={`Decrease quantity of ${item.name}`}>-</button>
                    <span className="cart-qty-value">{item.quantity}</span>
                    <button onClick={() => updateQuantity(item.id, item.quantity + 1)} className="cart-btn qty-btn" aria-label={`Increase quantity of ${item.name}`}>+</button>
                  </div>
                  <div className="cart-remove">
                    <button onClick={() => removeFromCart(item.id)} className="cart-btn remove-btn" aria-label={`Remove ${item.name} from cart`} title="Remove">×</button>
                  </div>
                </div>
              ))}
            </section>
            <section className="cart-summary" aria-label="Cart summary">
              <div className="summary-row">
                <span>subtotal</span>
                <span>${getCartTotal().toFixed(2)}</span>
              </div>
              <div className="summary-row">
                <span>shipping</span>
                <span>calculated at checkout</span>
              </div>
              <div className="summary-row total">
                <span>total</span>
                <span>${getCartTotal().toFixed(2)}</span>
              </div>
              <Link to="/checkout" className="checkout-button" aria-label="Proceed to checkout">
                proceed to checkout
              </Link>
            </section>
          </div>
        )}
      </div>
    </div>
  );
}

export default Cart; 